import { z } from 'zod';
import { UpdateAddressInputDTOSchema } from "../../../addresses/models/dtos/update-address.dto.js";
import { CreateBankAccountInputDTOSchema } from "../../../bank-accounts/models/dtos/create-bank-account.dto.js";
import { UpdateBankAccountInputDTOSchema } from "../../../bank-accounts/models/dtos/update-bank-account.dto.js";
import { BaseFacilityDTOSchema, } from "./facilities.dto.js";
// Schema for input validation when updating a facility
const UpdateFacilityInputDTOSchema = BaseFacilityDTOSchema.omit({
    slug: true,
    address: true,
    bankAccount: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
}).extend({
    legalName: z.string().min(2).max(128),
    address: UpdateAddressInputDTOSchema,
    bankAccount: z
        .union([UpdateBankAccountInputDTOSchema, CreateBankAccountInputDTOSchema])
        .nullable()
        .optional(),
});
// Request and response schemas for the API layer
export const UpdateFacilityRequestDTOSchema = z.object({
    body: UpdateFacilityInputDTOSchema.omit({
        id: true,
        companyId: true,
    }),
    params: z.object({
        companyId: UpdateFacilityInputDTOSchema.shape.companyId,
        facilityId: UpdateFacilityInputDTOSchema.shape.id,
    }),
});
//# sourceMappingURL=update-facility.dto.js.map